import apiClient from './apiClient';

const gatewaysService = {
  // Get all gateways for a Sales Organization
  getSoGateways: async (soId) => {
    const response = await apiClient.get(`/gateways/${soId}`);
    return response.data;
  },
  
  // Create a new gateway
  createGateway: async (data) => {
    const response = await apiClient.post('/gateways', data);
    return response.data;
  },
  
  // Update a gateway
  updateGateway: async (gatewayId, data) => {
    const response = await apiClient.put(`/gateways/${gatewayId}`, data);
    return response.data;
  },
  
  // Delete a gateway
  deleteGateway: async (gatewayId) => {
    const response = await apiClient.delete(`/gateways/${gatewayId}`);
    return response.data;
  },
  
  // Assign gateway to merchant
  assignGatewayToMerchant: async (data) => {
    const response = await apiClient.post('/gateways/assign-merchant', data);
    return response.data;
  },
  
  // Vault a card via payment session (returns stored card details)
  vaultCard: async (sessionId, { hostedCardId, customerId, customerData }) => {
    const response = await apiClient.post(`/payment-sessions/${sessionId}/vault`, {
      hostedCardId,
      customerId,
      customerData
    });
    return response.data;
  },

  // Check surcharge eligibility for a stored card
  checkSurcharge: async ({ storedCardId, amountCents }) => {
    const response = await apiClient.post('/gateways/check-surcharge', {
      storedCardId,
      amountCents
    });
    return response.data;
  },

  // Process payment through gateway
  // Extended timeout: vault delete+recreate and gateway round-trips can exceed 10s
  processPayment: async (data, { idempotencyKey } = {}) => {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {};
    const response = await apiClient.post('/gateways/process-payment', data, { timeout: 30000, headers });
    return response.data;
  },

  // Get merchant info from active gateway (Elavon /merchants/self)
  getMerchantInfo: async () => {
    const response = await apiClient.get('/gateways/merchant-info');
    return response.data;
  },

  // Check if payment processing is configured for the current company
  getPaymentStatus: async () => {
    const response = await apiClient.get('/gateways/payment-status');
    return response.data;
  }
};

export default gatewaysService;